var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformationCircle = function SvgInformationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18181B",
    d: "M14 3c6.075 0 11 4.925 11 11s-4.925 11-11 11S3 20.075 3 14 7.925 3 14 3m0 1C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4m-1.05 8.653c1.05-.525 2.233.424 1.948 1.564l-.827 3.308c-.077.311.245.57.531.427l.05-.024a.5.5 0 0 1 .447.894l-.05.025c-1.05.525-2.232-.424-1.947-1.564l.827-3.308a.375.375 0 0 0-.531-.427l-.05.024a.5.5 0 0 1-.447-.894zm1.059-3.528a.5.5 0 0 1 .5.5v.009a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5v-.009a.5.5 0 0 1 .5-.5z"
  })));
};
export default SvgInformationCircle;